<template>
    <ConfirmationModalWindow v-if="confirmationToDeleteWindowIsOpened" v-model:isOpened="confirmationToDeleteWindowIsOpened" title="Вы уверены, что хотите удалить выплату?" @confirm="deletePayout"/>
    <div class="">
        <div class="fixed bg-gray-500 opacity-50 h-screen w-screen top-0 left-0 right-0 z-10"></div>
        <div @click="closeWindow" class="fixed top-0 left-0 right-0 w-full h-full flex items-center justify-center z-20">
            <div @click.stop class="relative flex flex-col justify-between bg-white z-50 max-h-[95vh] w-[45vw] rounded-lg py-10 px-16 overflow-y-scroll no-scrollbar">
                <svg @click="closeWindow" class="w-8 h-8 absolute top-[10px] right-[12px] text-gray-500 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                <div>
                    <p class="text-2xl mb-8">
                        <span>Детали выплаты</span>
                        <span v-if="currentPayout.is_deleted" class="text-xl text-red-500 ml-4">(удалена)</span>
                    </p>
                    <div class="grid grid-cols-6 gap-4 mb-8">
                        <div class="relative col-span-2">
                            <span class="mb-1 block text-sm text-gray-500">Дата создания</span>
                            <p class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
                                <span>{{ $globalMethods.formatDate('ru', currentPayout.datetime_of_created) }}</span>  
                            </p>
                        </div>
                        <div class="relative col-span-2">
                            <span class="mb-1 block text-sm text-gray-500">Период</span>
                            <p class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
                                <span>{{ $globalMethods.getMonthAndYear(currentPayout.target_period) }}</span>  
                            </p>
                        </div>
                        <div class="relative col-span-2">
                            <span class="mb-1 block text-sm text-gray-500">Тип выплаты</span>
                            <p class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
                                <span>{{ labels.payoutTypes[currentPayout.type] }}</span>  
                            </p>
                        </div>
                        <div class="relative col-span-3">
                            <span class="mb-1 block text-sm text-gray-500">Сотрудник</span>
                            <p class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
                                <span>{{ currentPayout.staff.name }}</span>  
                            </p>
                        </div>
                        <div class="relative col-span-3">
                            <span class="mb-1 block text-sm text-gray-500">Размер выплаты</span>
                            <p class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
                                <span>{{ $globalMethods.formatNumberWithSpaces(currentPayout.total) }}</span>  
                            </p>
                        </div>
                        <div class="relative col-span-6">
                            <span class="mb-1 block text-sm text-gray-500">Комментарий</span>
                            <p class="w-full text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4 min-h-[2.375rem]" type="button">
                                <span>{{ currentPayout.note }}</span>  
                            </p>
                        </div>
                    </div>
                </div>
                <button v-if="!currentPayout.is_deleted && hasAccessToDeletePayout" @click.stop="openConfirmationToDeleteWindow" ref="deletePayoutButton" :disabled="false" type="button" class="text-center bg-red-500 hover:bg-red-600 flex items-center justify-center text-white font-medium rounded-lg text-sm px-5 py-2">Удалить</button>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import ConfirmationModalWindow from '@/components/modal/ConfirmationModalWindow.vue';

    export default {
        name: "PayoutDetailWindow",
        components: {
            ConfirmationModalWindow,
        },
        props: {
            isOpened: {
                type: Boolean,
                required: true,
            },
            currentPayout: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                confirmationToDeleteWindowIsOpened: false,
            }
        },
        computed: {
            ...mapState(["role", "labels", "currentSchedulePeriod"]),
            hasAccessToDeletePayout() {
                return this.role === "founder" && this.checkPeriodToEditable();
            },
        },
        methods: {
            checkPeriodToEditable() {
                const currentSchedulePeriodDate = new Date(this.currentSchedulePeriod.date);
                let today = new Date();
                let firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);                
                let lastDayNextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);
                return currentSchedulePeriodDate >= firstDayLastMonth && currentSchedulePeriodDate <= lastDayNextMonth
            },
            openConfirmationToDeleteWindow() {
                this.confirmationToDeleteWindowIsOpened = true;
            },
            async deletePayout() {
                const response = await this.$store.dispatch("deletePayout", this.currentPayout.id);
                if (response.successfully) {
                    this.$notify("Выплата успешно удалена!", "black", 3000);
                    this.closeWindow();
                }
            },
            closeWindow() {
                document.body.classList.remove("overflow-hidden");
                this.$emit("update:isOpened", false);
            }
        }
    }
</script>